/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcAgToggleButtonComponent} from './fc-ag-toggle-button.component';


/**
 * Fc AG Toggle button module.
 */
@NgModule({
    declarations: [
        FcAgToggleButtonComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FcAgToggleButtonComponent
    ]
})

export class FcAgToggleButtonModule {
}
